import Login from "./auth/Login";
import ForgotPassword from "./auth/ForgotPassword";
import OtpVerification from "./auth/otp";
import ResetPassword from "./auth/ResetPassword";
import Dashboard from "./dashboard";
import ManageCustomers from "./manageEmployer";
import ManageCustomerDetail from "./manageEmployer/view";
import ManageMaintenanceTeam from "./manageFreelancer";
import ManageCategories from "./manageCategories";
import ManagePayments from "./managePayments";
import ManageSubadmin from "./manageSubadmin";
import ManageCustomerSupport from "./manageCustomerSupport";
import ManageNotifications from "./manageNotifications";
import RecievedNotifications from "./recievedNotifications";
import ManageReviews from "./manageReviews";
import ManageCms from "./manageCms";
import AddCustomer from "./manageEmployer/add";
import AddTeam from "./manageFreelancer/add";
import SubadminDetail from "./manageSubadmin/viewSubadmin";
import AddSubadmin from "./manageSubadmin/addSubadmin";
import ManageSubadminRoles from "./manageSubadmin/roles";
import AddRole from "./manageSubadmin/addRole";
import RoleDetail from "./manageSubadmin/viewRole";
import MaintenanceTeamDetail from "./manageFreelancer/view";
import ManageIssues from "./manageRefund";
import ManageOffers from "./manageRefund/offers";
import ManageProfile from "./manageProfile";
import EditProfile from "./manageProfile/edit";
import PortfolioDetails from "./manageFreelancer/portfolioDetails";

import ChangePassword from "./manageProfile/changePassword";

//
import TaskDetail from "./manageEmployer/TaskDetail";
import ViewWorkHistory from "./manageFreelancer/viewWorkHistory";
import ViewCategory from "./manageCategories/view";
import ServiceList from "./manageCategories/services";
import EditPorfolio from "./manageFreelancer/editPortfolio";
import ManageTasks from "./manageTask";
import ManageMessage from "./paymentMessage";
import PaymentFailure from "./paymentMessage/paymentFailure";
import ManagePayout from "./managePayout";
import ManageWallet from "./manageWallet";
export default {
  Login,
  ForgotPassword,
  OtpVerification,
  ResetPassword,
  Dashboard,
  ManageCustomers,
  ManageCustomerDetail,
  AddCustomer,
  ManageMaintenanceTeam,
  MaintenanceTeamDetail,
  AddTeam,
  ManageIssues,
  ManageOffers,
  ManageCategories,
  ManagePayments,
  ManageSubadmin,
  SubadminDetail,
  AddSubadmin,
  ManageSubadminRoles,
  AddRole,
  RoleDetail,
  ManageCustomerSupport,
  ManageNotifications,
  RecievedNotifications,
  ManageReviews,
  ManageCms,
  ManageProfile,
  EditProfile,
  ChangePassword,
  TaskDetail,
  ViewWorkHistory,
  ViewCategory,
  ServiceList,
  PortfolioDetails,
  EditPorfolio,
  ManageTasks,
  ManageMessage,
  PaymentFailure,
  ManagePayout,
  ManageWallet,
};
